import React, { useState } from 'react';
import './ProjectInquiry.css';
import { WovenLightHero as HeroSectionOne } from './ui/woven-light-hero';
import ProjectInquiryFormLayout from './ui/form-layout';

const ProjectInquiry = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    website: '',
    projectType: '',
    projectDetails: '',
    budget: '',
    timeline: '',
    wantExamples: false,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const setField = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredMissing =
      !formData.name?.trim() ||
      !formData.email?.trim() ||
      !formData.projectDetails?.trim() ||
      !formData.projectType ||
      !formData.budget ||
      !formData.timeline;

    if (requiredMissing) {
      setSubmitStatus('Please complete all required fields.');
      setTimeout(() => setSubmitStatus(''), 4500);
      return;
    }

    setSubmitStatus('Please wait...');

    const formDataToSubmit = {
      access_key: '110c138e-b70b-4420-8d05-7817cc4a4101',
      name: formData.name,
      email: formData.email,
      website: formData.website || 'Not provided',
      projectType: formData.projectType,
      message: formData.projectDetails,
      budget: formData.budget,
      timeline: formData.timeline,
      wantExamples: formData.wantExamples ? 'Yes' : 'No',
      botcheck: false,
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formDataToSubmit),
      });

      const json = await response.json();

      if (response.status === 200) {
        setSubmitStatus('Form submitted successfully');
        setIsSubmitted(true);
        setFormData({
          name: '',
          email: '',
          website: '',
          projectType: '',
          projectDetails: '',
          budget: '',
          timeline: '',
          wantExamples: false,
        });
      } else {
        console.error('Form submission failed:', json);
        setSubmitStatus(
          json.message || 'Something went wrong. Please try again.',
        );
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus(
        'Network error. Please check your connection and try again.',
      );
    }

    setTimeout(() => {
      setSubmitStatus('');
    }, 5000);
  };

  if (isSubmitted) {
    return (
      <div className="project-inquiry project-inquiry--submitted">
        <div className="thank-you-section">
          <h1>
            Thanks! I'll review your info and get back to you within 24 hours.
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="project-inquiry">
      <div className="dark border-b border-white/10 bg-black">
        <HeroSectionOne
          eyebrow="Response within 24 hours"
          eyebrowHref="#project-inquiry-main"
          headline="Start your project"
          subtitle="Let's create something amazing together. Tell us what you're building, your timeline, and budget—we'll reply with a clear plan."
          ctaLabel="Continue to form"
          ctaHref="#project-inquiry-main"
          className="my-0 scroll-mt-20"
        />
      </div>

      <div id="project-inquiry-main" className="project-inquiry-content dark">
        <ProjectInquiryFormLayout
          formData={formData}
          onFieldChange={setField}
          onSubmit={handleSubmit}
          submitStatus={submitStatus}
          onCancel={() =>
            document.getElementById('hero')?.scrollIntoView?.({
              behavior: 'smooth',
            })
          }
        />
      </div>
    </div>
  );
};

export default ProjectInquiry;
